// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"b7b0b3d3","388":"7a5bb55d","619":"6bceaed7","638":"6b12665a","803":"a9ab2d3e","828":"4a95f0b7","893":"4c3faee7"}[chunkId] + ".chunk.js";
};